import React, { useState, useEffect } from "react";
import { EVENTS } from "../../mock";
import { Calendar, MapPin, Clock } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { Badge } from "../ui/badge";
import { SectionTitle } from "./About";
import { listEvents } from "../../lib/api";

export default function Events() {
  const [extra, setExtra] = useState([]);
  useEffect(() => {
    let mounted = true;
    listEvents()
      .then((data) => { if (mounted) setExtra(data || []); })
      .catch(() => { /* fall back to mock only */ });
    return () => { mounted = false; };
  }, []);

  const all = [...extra, ...EVENTS];
  const upcoming = all.filter(e => e.type === "upcoming");
  const past = all.filter(e => e.type === "past");
  const fmt = d => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  const Card = ({ e, upcoming }) => (
    <div className={`rounded-2xl p-6 lift ${upcoming ? "bg-emerald-deep text-ivory" : "bg-ivory border border-stone-200/60"}`}>
      <div className="flex items-start justify-between gap-3">
        <Badge className={upcoming ? "bg-gold text-emerald-deep hover:bg-gold" : "bg-stone-200 text-stone-700 hover:bg-stone-200"}>
          {upcoming ? "Upcoming" : "Past Event"}
        </Badge>
        <Clock className={`w-4 h-4 ${upcoming ? "text-gold" : "text-stone-400"}`} />
      </div>
      <h3 className={`font-display text-xl mt-4 ${upcoming ? "text-ivory" : "text-emerald-deep"}`}>{e.title}</h3>
      <div className={`mt-3 flex flex-wrap gap-4 text-sm ${upcoming ? "text-ivory/85" : "text-stone-600"}`}>
        <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {fmt(e.date)}</span>
        <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {e.location}</span>
      </div>
      <p className={`mt-4 text-sm leading-relaxed ${upcoming ? "text-ivory/80" : "text-stone-600"}`}>{e.description}</p>
    </div>
  );

  return (
    <section id="events" className="scroll-smooth-section py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Calendar"
          title="Events & community camps"
          subtitle="Upcoming public lectures, free health camps and book releases — plus a record of recent events."
        />

        <Tabs defaultValue="upcoming" className="mt-10">
          <TabsList className="bg-cream border border-saffron/30 p-1.5">
            <TabsTrigger value="upcoming" className="data-[state=active]:!bg-emerald-deep data-[state=active]:!text-ivory data-[state=active]:shadow-md text-stone-700 px-5 font-medium">Upcoming ({upcoming.length})</TabsTrigger>
            <TabsTrigger value="past" className="data-[state=active]:!bg-emerald-deep data-[state=active]:!text-ivory data-[state=active]:shadow-md text-stone-700 px-5 font-medium">Past ({past.length})</TabsTrigger>
          </TabsList>
          <TabsContent value="upcoming" className="mt-7">
            <div className="grid md:grid-cols-2 gap-6">
              {upcoming.length ? upcoming.map(e => <Card key={e.id} e={e} upcoming />) : <p className="text-stone-500">No upcoming events posted yet.</p>}
            </div>
          </TabsContent>
          <TabsContent value="past" className="mt-7">
            <div className="grid md:grid-cols-2 gap-6">
              {past.map(e => <Card key={e.id} e={e} />)}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
}
